const {
  HeadCellAdmin,
} = require("../../../../../../../dumb/TableHeadCell/components/HeadCellAdmin");
const React = require("react");

module.exports = ({self, items, fullSize}) => {
  const state = self.state;

  return (
    <>
      <div className={`rlv h100vh-440 h100vh-315@m2 h100vh-325.fullSize h100vh-210@m2.fullSize` + (fullSize ? ' fullSize' : '')}>
        <div className="ovxA abs s">
          <div className="wmin1360 rlv h">
            <div className="w abs bgE layoutRow aiStretch">
              <HeadCellAdmin className="wmin185 fx1">
                Lock Date
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Release Date
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Payment Gateway
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Reserve Rate
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Reserved Amount
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin200">
                Status
              </HeadCellAdmin>
            </div>
            <div className="abs sh st45 sb c0>.CircularProgress">
              {items}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
